import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'performance';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = {
            current,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe888;</i><span>竞争公司表现</span></span>}>
                        <Menu.Item key="performance">
                            <a href="#/competeCompany/performance">竞争公司表现</a>
                        </Menu.Item>
                        <Menu.Item key="compare">
                            <a href="#/competeCompany/compare">津石与竞争公司对比</a>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/competeCompany/SideNav.js